module.exports = __webpack_public_path__ + "img/135.5fc16146.jpg";